import React from 'react';

/**
 * SVG pattern definitions for chart fills.
 * Drop this inside any <svg> or Recharts <defs> to enable pattern-based fills.
 * Usage: fill="url(#pattern-diagonal-{color})"
 */
interface ChartPatternDefsProps {
  colors: string[];
}

export function ChartPatternDefs({ colors }: ChartPatternDefsProps) {
  return (
    <defs>
      {colors.map((color, i) => {
        const patternType = i % 8;
        const id = `pattern-${i}`;
        const stroke = color;
        const fill = color;

        switch (patternType) {
          case 0: // solid
            return (
              <pattern key={id} id={id} width="10" height="10" patternUnits="userSpaceOnUse">
                <rect width="10" height="10" fill={fill} />
              </pattern>
            );
          case 1: // diagonal lines
            return (
              <pattern key={id} id={id} width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
                <rect width="8" height="8" fill={fill} opacity="0.3" />
                <line x1="0" y1="0" x2="0" y2="8" stroke={stroke} strokeWidth="3" />
              </pattern>
            );
          case 2: // dots
            return (
              <pattern key={id} id={id} width="8" height="8" patternUnits="userSpaceOnUse">
                <rect width="8" height="8" fill={fill} opacity="0.2" />
                <circle cx="4" cy="4" r="2" fill={fill} />
              </pattern>
            );
          case 3: // crosshatch
            return (
              <pattern key={id} id={id} width="8" height="8" patternUnits="userSpaceOnUse">
                <rect width="8" height="8" fill={fill} opacity="0.2" />
                <line x1="0" y1="0" x2="8" y2="8" stroke={stroke} strokeWidth="1.5" />
                <line x1="8" y1="0" x2="0" y2="8" stroke={stroke} strokeWidth="1.5" />
              </pattern>
            );
          case 4: // horizontal lines
            return (
              <pattern key={id} id={id} width="8" height="8" patternUnits="userSpaceOnUse">
                <rect width="8" height="8" fill={fill} opacity="0.2" />
                <line x1="0" y1="4" x2="8" y2="4" stroke={stroke} strokeWidth="2" />
              </pattern>
            );
          case 5: // vertical lines
            return (
              <pattern key={id} id={id} width="8" height="8" patternUnits="userSpaceOnUse">
                <rect width="8" height="8" fill={fill} opacity="0.2" />
                <line x1="4" y1="0" x2="4" y2="8" stroke={stroke} strokeWidth="2" />
              </pattern>
            );
          case 6: // zigzag
            return (
              <pattern key={id} id={id} width="12" height="8" patternUnits="userSpaceOnUse">
                <rect width="12" height="8" fill={fill} opacity="0.2" />
                <polyline points="0,8 3,0 6,8 9,0 12,8" fill="none" stroke={stroke} strokeWidth="1.5" />
              </pattern>
            );
          case 7: // grid
            return (
              <pattern key={id} id={id} width="8" height="8" patternUnits="userSpaceOnUse">
                <rect width="8" height="8" fill={fill} opacity="0.2" />
                <line x1="4" y1="0" x2="4" y2="8" stroke={stroke} strokeWidth="1" />
                <line x1="0" y1="4" x2="8" y2="4" stroke={stroke} strokeWidth="1" />
              </pattern>
            );
          default:
            return null;
        }
      })}
    </defs>
  );
}
